import { store } from '@/app/store';
import { selectedMarketSelector } from '@/features/selectedMarket/selectedMarketSlice';
import Icon from '@/shared/components/Icon/Icon';
import { menuItems } from '@/shared/config/menuItems';
import { IonBadge, IonCol, IonLabel, IonRouterLink } from '@ionic/react';
import { useHistory } from 'react-router';
import styles from './MenuItem.module.css';
import { t } from 'i18next';

type MenuItemType = {
  url: string;
  title: string;
  icon: string;
};

type Props = {
  index?: number;
  item: MenuItemType;
  showNotificationForTravelRule?: boolean;
  notificationCount: number;
};

const MenuItem: React.FC<Props> = ({ index, item, showNotificationForTravelRule, notificationCount }) => {
  const history = useHistory();
  const userSelectedMarket = selectedMarketSelector.selectAll(store.getState());
  const isInvestRoute = item.url === '/markets' && userSelectedMarket[0];
  const userInvestRoute = isInvestRoute ? `${item.url}/${userSelectedMarket[0].market}` : item.url;

  return (
    <IonCol
      className={`ion-align-self-center ${index === menuItems.length - 1 ? null : styles.linkContainer}`}
      size="auto"
    >
      <IonRouterLink
        color="menu-texts"
        href={isInvestRoute ? userInvestRoute : item.url}
        className={`${styles.link} ${location.pathname.includes(item.url) ? styles.linkActive : undefined}`}
        data-testId={`ion-menu-item-${item.title}`}
        onClick={(e) => {
          e.preventDefault();
          history.push(isInvestRoute ? userInvestRoute : item.url);
        }}
      >
        <IonLabel className={styles.label}>
          <Icon size="xmedium" color="menu-texts" src={`assets/icons/${item.icon}.svg`} />
          <span className={styles.labelTitle}>{t(item.title)}</span>
          {notificationCount > 0 && showNotificationForTravelRule && (
            <IonBadge color="warning" className={styles.notificationBadge}>
              {notificationCount > 99 ? '99+' : notificationCount}
            </IonBadge>
          )}
        </IonLabel>
      </IonRouterLink>
    </IonCol>
  );
};
export default MenuItem;
